import Commodity from "./commodity";

export interface Alert {
    id: string;
    isIgnorable: boolean;
    alertType: AlertType;
    level: AlertLevel;
    data: any;
}

export enum AlertType {
    ExpiringOffer = 1,
    ExpiringBidEditorSymbols = 2,
    ErpSyncFailureContract = 3,
    ExpiringContract = 4,
    Risk = 5,
    PendingOffers = 6,
    RejectedOrder = 7,
}

export enum AlertLevel {
    Informational = 1,
    Warning = 2,
    Error = 3
}

export interface ExpiringOfferData {
    offerId: number;
    displayId: string;
    expirationDate: Date;
}

export interface ExpiringContractData {
    contractId: number;
    displayId: string;
    finalPricingDate: Date;
}

export interface ExpiringBidEditorSymbolData {
    symbol: string;
    expiration: Date;
    commodities: Commodity[];
}